import * as React from 'react';

import { Textfit } from '@wwe-portal/ui/components/text-fit';

interface OfferHeaderProps {
  children: React.ReactNode;
  maxFont: number;
}
export const OfferHeader: React.FC<OfferHeaderProps> = ({
  children,
  maxFont,
}) => {
  return (
    <Textfit
      className="flex h-full w-full items-center justify-center stroke-2 px-1 text-center font-semibold uppercase leading-normal text-white"
      max={maxFont}
      mode="multi"
    >
      {children}
    </Textfit>
  );
};
